<div [loadingOverlay]="isLoading">
	@if (reportingSite) {
		<div class="card mb-3">
			<div class="card-header">
				<h6 class="mb-0">Branding</h6>
			</div>
			<div class="card-body">
				<label class="control-label">Primary Color</label>
				<div class="d-flex align-items-center gap-2">
					<input type="color" [ngModel]="reportingSite.PrimaryColor || '#55acf4'"
						(ngModelChange)="reportingSite.PrimaryColor = $event" [ngModelOptions]="{ standalone: true }"
						style="width: 60px; height: 38px; padding: 0; border: 1px solid #ced4da; border-radius: 4px; cursor: pointer;" />
					<input type="text" [(ngModel)]="reportingSite.PrimaryColor"
						[ngModelOptions]="{ updateOn: 'blur', standalone: true }" class="form-control"
						placeholder="#55acf4" style="max-width: 120px;" />
					<button *ngIf="reportingSite.PrimaryColor" (click)="reportingSite.PrimaryColor = null"
						class="btn btn-link text-danger p-0" title="Clear">
						<i class="fa fa-times"></i>
					</button>
				</div>
				<p class="text-muted small mt-1 mb-0">Applies to icon backgrounds, buttons, and chart colors</p>
			</div>
		</div>
		<div class="card mb-3">
			<div class="card-header">
				<h6 class="mb-0">Logos</h6>
			</div>
			<div class="card-body">
				<p class="text-muted small mb-3">Overrides the partner logo on the reporting site. Recommended max size: 300×75px.</p>
				<div class="row">
					<div class="col-md-6 mb-3 mb-md-0">
						<div class="border rounded p-3 h-100" style="background-color: #ffffff;">
							<div class="d-flex justify-content-between align-items-center mb-2">
								<span class="fw-semibold small">Light Mode</span>
								<button *ngIf="reportingSite.LightModeLogoUrl" (click)="reportingSite.LightModeLogoUrl = null"
									class="btn btn-link text-danger p-0 btn-sm" title="Clear">
									<i class="fa fa-times"></i>
								</button>
							</div>
							<div class="d-flex align-items-center justify-content-center mb-3" style="min-height: 75px;">
								<img *ngIf="reportingSite.LightModeLogoUrl" [attr.src]="reportingSite.LightModeLogoUrl"
									alt="Light Mode Logo" style="max-width: 100%; max-height: 75px;"/>
								<span *ngIf="!reportingSite.LightModeLogoUrl" class="text-muted small">No logo uploaded</span>
							</div>
							<div class="text-center">
								<button (click)="uploadLightModeLogo()" class="btn btn-sm"
									style="background-color: #ffffff; color: #344054; border: 1px solid #d0d5dd;">
									<i class="fa fa-upload me-1"></i>
									Upload
								</button>
							</div>
						</div>
					</div>
					<div class="col-md-6">
						<div class="border rounded p-3 h-100" style="background-color: #101828;">
							<div class="d-flex justify-content-between align-items-center mb-2">
								<span class="fw-semibold small text-white">Dark Mode</span>
								<button *ngIf="reportingSite.DarkModeLogoUrl" (click)="reportingSite.DarkModeLogoUrl = null"
									class="btn btn-link text-danger p-0 btn-sm" title="Clear">
									<i class="fa fa-times"></i>
								</button>
							</div>
							<div class="d-flex align-items-center justify-content-center mb-3" style="min-height: 75px;">
								<img *ngIf="reportingSite.DarkModeLogoUrl" [attr.src]="reportingSite.DarkModeLogoUrl"
									alt="Dark Mode Logo" style="max-width: 100%; max-height: 75px;"/>
								<span *ngIf="!reportingSite.DarkModeLogoUrl" class="small" style="color: #98a2b3;">No logo uploaded</span>
							</div>
							<div class="text-center">
								<button (click)="uploadDarkModeLogo()" class="btn btn-sm"
									style="background-color: #1d2939; color: #98a2b3; border: 1px solid #344054;">
									<i class="fa fa-upload me-1"></i>
									Upload
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		@if (!isBoostabilityOrManta) {
		<div class="card mb-3">
			<div class="card-header">
				<h6 class="mb-0">Privacy Policy</h6>
			</div>
			<div class="card-body">
				<label class="control-label">Privacy Policy URL</label>
				<input type="text" class="form-control"
					[formControl]="privacyPolicyUrlControl"
					[formValidation]="privacyPolicyUrlControl"
					placeholder="https://example.com/privacy-policy" />
				<p class="text-muted small mt-1 mb-0">External URL to the partner's privacy policy.</p>
			</div>
		</div>
		} @else {
		<div class="card mb-3">
			<div class="card-body text-muted small">
				Privacy policy is managed internally for this partner.
			</div>
		</div>
		}

		<!-- murder: Remove this card after MMI v3 rollout — HiddenContent, Css, ChartColors, and LoadingIconUrl are deprecated in v3. -->
		<div class="card mb-3">
			<div class="card-header text-muted" style="cursor: pointer;" (click)="isLegacyCollapsed = !isLegacyCollapsed">
				<h6 class="mb-0">
					<i class="fa me-1" [ngClass]="isLegacyCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
					Legacy Settings
				</h6>
			</div>
			<div [(ngbCollapse)]="isLegacyCollapsed">
				<div class="card-body">
					<div class="form-group">
						<label class="control-label">Hidden Elements</label>
						<textarea [(ngModel)]="reportingSite.HiddenContent"
							[ngModelOptions]="{ updateOn: 'blur', standalone: true }" class="form-control"
							rows="6"></textarea>
						<p class="text-muted small mt-1 mb-0">Comma separated list of elements to hide</p>
					</div>
					<div class="form-group">
						<label class="control-label">Custom CSS</label>
						<textarea [(ngModel)]="reportingSite.Css"
							[ngModelOptions]="{ updateOn: 'blur', standalone: true }" class="form-control"
							rows="6"></textarea>
					</div>
					<div>
						<ng-container *ngFor="let $data of chartColors">
							<div class="form-group">
								<label class="control-label">
									Chart Color
									<span>{{$data.Index()}}</span>
									.
								</label>
								<input [dataValidation]="{ placement: 'top', value: $data.Color }" [ngModel]="$data.Color()"
									(ngModelChange)="$data.Color($event)"
									[ngModelOptions]="{ updateOn: 'blur', standalone: true }" type="text"
									class="form-control" />
							</div>
						</ng-container>
					</div>
					<div class="form-group">
						<label class="control-label">Loading Icon</label>
						<div>
							<button (click)="uploadLoadingIcon()" class="btn btn-primary btn-sm">
								<i class="fa fa-upload"></i>
								Upload File
							</button>
							<img [hidden]="!reportingSite.LoadingIconUrl" [attr.src]="reportingSite.LoadingIconUrl"
								alt="Loading Icon" class="img-rounded" height="100" width="100" />
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- end murder -->
	}
	<div class="text-end mt-3">
		<button (click)="save()" class="btn btn-success">
			<i class="fa fa-save"></i>
			Save
		</button>
	</div>
</div>
